import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';

import type { TitleDetail, TitleDetailSeason } from '@/interfaces/title-details-graphql';

import { useLanguageStore } from '@/helpers/composables/useStores';
import { formattedReleaseDate } from '@/helpers/date-helper';
import { UpcomingReleaseLabel } from '@/@types/graphql-types';
import { UpcomingReleaseForSpinningText } from '@/features/buybox/helpers/upcoming-helpers';
import UpcomingSpinningSegment from '@/components/details/spinning-text/UpcomingSpinningSegment.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'Upcoming',
  props: {
    title: null,
    upcomingDigitalReleases: null
  },
  setup(__props: any) {

const props = __props as {
	title: TitleDetail | TitleDetailSeason;
	upcomingDigitalReleases: UpcomingReleaseForSpinningText[];
};



const { language, country } = useLanguageStore();

const titleName = computed(() => {
	if ((props.title as TitleDetailSeason).show) {
		return `${(props.title as TitleDetailSeason).show.content.title} ${props.title.content.title}`;
	}

	return props.title.content.title;
});

// when there are no complete upcoming releases, there may be a generic upcoming release (either empty package, or imdbmeta scrape) where we can get the release date
const genericUpcomingRelease = computed(() =>
	props.title.content.upcomingReleases?.find(
		el => el.releaseType === 'DIGITAL' && (!el.package || ['imd', 'tmd'].includes(el.package.shortName))
	)
);

const formattedDate = computed(() => {
	if (!genericUpcomingRelease.value) return null;
	return formattedReleaseDate(
		genericUpcomingRelease.value.releaseDate,
		genericUpcomingRelease.value.label,
		language.value,
		'long',
		country.value,
		true
	).heading;
});

const releaseLabelIsSeason = computed(
	() =>
		genericUpcomingRelease.value &&
		[
			UpcomingReleaseLabel.Autumn,
			UpcomingReleaseLabel.Winter,
			UpcomingReleaseLabel.Spring,
			UpcomingReleaseLabel.Summer,
		].includes(genericUpcomingRelease.value.label)
);

return { __sfc: true,props, language, country, titleName, genericUpcomingRelease, formattedDate, releaseLabelIsSeason, UpcomingReleaseLabel, UpcomingSpinningSegment }
}

})